import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { ClassNames } from '@emotion/react';

import { ReactComponent as ArrowDown } from '../../../assets/icons/Arrow-Down.svg';
import { ReactComponent as ArrowLeft } from '../../../assets/icons/arrow-left.svg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/arrow-right.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/calendar-icon.svg';
import { ReactComponent as CalendarDisabledIcon } from '../../../assets/icons/calendar-disabled-icon.svg';

import { CustomField } from '../../../models/types/CustomField';
import { CustomFieldLabel } from '../../../models/types/CustomFieldLabel';
import DatePickerInput from './DatePickerInput/DatePickerInput';
import { useDatePicker } from './datePicker.hooks';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_MASK,
} from '../../../utils/dateHelpers';
import { DatePickerView } from './datePicker.models';
import { datePickerStyles } from './datePicker.styles';

export type DatePickerProps = CustomField &
  CustomFieldLabel & {
    onChange?: (value: string) => void;
    value: string;
    isError?: boolean;
    onBlur?: () => void;
    onInputChange?: () => void;
    onClose?: () => void;
    views?: DatePickerView[];
    autoComplete?: string;
    autoCorrect?: string;
    inputFormat?: string;
    outputFormat?: string;
    format?: string;
    mask?: string;
  };

const DatePicker = ({
  className,
  disabled,
  readOnly,
  onChange,
  value,
  isLabelHidden,
  label,
  placeholder,
  labelAnimation,
  isError,
  onBlur,
  onInputChange,
  onClose,
  views,
  autoComplete,
  autoCorrect,
  outputFormat,
  mask,
  format,
  ...props
}: DatePickerProps) => {
  const { onChangeHandler, currentValue } = useDatePicker({
    onChange,
    value,
    outputFormat,
    inputFormat: props.inputFormat,
  });

  return (
    <ClassNames>
      {({ css }) => (
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDatePicker
            {...props}
            inputFormat={format || DEFAULT_DATE_FORMAT}
            mask={mask || DEFAULT_DATE_MASK}
            disableMaskedInput={false}
            disabled={disabled}
            readOnly={readOnly}
            onChange={onChangeHandler}
            onClose={onClose}
            views={views || ['year', 'month', 'day']}
            value={currentValue}
            components={{
              OpenPickerIcon:
                disabled || readOnly ? CalendarDisabledIcon : CalendarIcon,
              RightArrowIcon: ArrowRight,
              LeftArrowIcon: ArrowLeft,
              SwitchViewIcon: ArrowDown,
            }}
            PopperProps={{
              className: css([datePickerStyles]),
            }}
            InputAdornmentProps={{ position: 'start' }}
            renderInput={(params: any) => (
              <DatePickerInput
                {...params}
                disabled={disabled}
                readOnly={readOnly}
                autoComplete={autoComplete}
                autoCorrect={autoCorrect}
                onBlur={onBlur}
                onChange={onInputChange}
                label={label}
                isError={isError}
                isLabelHidden={isLabelHidden}
                placeholder={placeholder}
                labelAnimation={labelAnimation}
              />
            )}
          />
        </LocalizationProvider>
      )}
    </ClassNames>
  );
};

export default DatePicker;
